import React from 'react';
import { Box, Fade, styled, Typography } from '@mui/material';
import assessmentsLoading from 'assets/lotties/AssessmentsLoading.lottie';
import { DotLottie } from 'components/DotLottie/DotLottie';
import {
  ASSESSMENTS_LOADER_HEIGHT_MOBILE,
  ASSESSMENTS_LOADER_HEIGHT_DESKTOP_TABLET,
} from 'features/assessments/constants';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';

const ContentLoadingWrapper = styled(Box)(({ theme }) => ({
  height: '100vh',
  width: '100vw',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.brandBackgroundPrimary.main,
}));

const LoadingContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const AssessmentsContentLoading = () => {
  const { isMobile } = useDeviceType();

  return (
    <ContentLoadingWrapper>
      <Fade in timeout={1000}>
        <LoadingContent>
          <Box
            height={
              isMobile ? ASSESSMENTS_LOADER_HEIGHT_MOBILE : ASSESSMENTS_LOADER_HEIGHT_DESKTOP_TABLET
            }
          >
            <DotLottie src={assessmentsLoading} autoplay loop />
          </Box>
          <Typography variant={isMobile ? 'callout' : 'headline'} sx={{ mt: 5 }}>
            Hang tight, we&apos;re loading your assessment.
          </Typography>
          <Typography variant={isMobile ? 'callout' : 'headline'}>
            This should only take a moment.
          </Typography>
        </LoadingContent>
      </Fade>
    </ContentLoadingWrapper>
  );
};
